// Import and register all Stimulus controllers

import { application } from "./application"

// Import controllers
import ManualReviewController from "./manual_review_controller"
import PopoverController from "./ui/popover_controller"
import DropdownController from "./ui/dropdown_controller"
import SourceDrawerController from "./source_drawer_controller"

// Register controllers
application.register("manual-review", ManualReviewController)
application.register("ui--popover", PopoverController)
application.register("ui--dropdown", DropdownController)
application.register("source-drawer", SourceDrawerController)
